import { take, select, put, call } from 'redux-saga/effects'
import { REHYDRATE } from 'redux-persist'
import { LOAD_AUTH_USER_SUCCESS, LOGOUT_KEYCLOAK, LOGOUT_SUCCESS } from './actionTypes'
import { resetState } from '../_BETA/utils'
import * as eventTracking from '../../../utils/eventTracking'
import UserService from '../../../utils/keycloak/UserService'

export function* logout () {
  while (true) {
    yield take(LOGOUT_KEYCLOAK)
    // Reset segment
    if (window.analytics) {
      window.analytics.reset()
    }

    // Reset persisted state
    // TODO: The store value here can't be asserted until client.js is converted
    // to TypeScript

    const store: any = require('../../../client').store
    const state = resetState(store.getState())
    localStorage.setItem('persist:state', JSON.stringify({ state }))
    // Complete logout flow and trigger redirect
    yield call(logoutFromKeycloak);
    yield put({ type: LOGOUT_SUCCESS })
  }
}

function logoutFromKeycloak () {
  return new Promise(() => {
    UserService.doLogout();
  });
}

export function* analyticsIdentify (): Generator<any, any, any> {
  yield take(REHYDRATE)
  let loggedInUser = null // NOTE: Intentionally null

  let existingUser = yield select((state: Insite.AppState) => state.auth.user)
  // If there is nothing from the persisted state, wait until they've logged in
  // and set the logged in user value
  if (!existingUser || !existingUser.token) {
    const { result } = yield take(LOAD_AUTH_USER_SUCCESS)
    loggedInUser = result
  }

  if (process.env.SEGMENT_WRITE_KEY && window.analytics) {
    window.analytics.load(process.env.SEGMENT_WRITE_KEY)

    // If the logged in user value is not null, someone has had to log in
    // manually. Set this to the existing user value and track that they've
    // logged in
    if (loggedInUser !== null) {
      existingUser = loggedInUser
      eventTracking.userLogin()
    }

    // NOTE: We intentionally do not 'alias' users as we only want to track
    // registered, logged in users
    // Identify a user after the user object is fetched. We want to do this
    // on any page change (or 'refresh' in a client app)
    window.analytics.identify(existingUser.id, {
      email: existingUser.email,
      name: existingUser.display_name,
      product: 'Bonfire'
    })
  }
}
